// extracted by mini-css-extract-plugin
export default {"container":"calculatorSlider_container__DdHJz","right":"calculatorSlider_right__V4yMw","title":"calculatorSlider_title__-UTle"};